<template>
  <span>
      <span v-if="isActive">
        <Button :type="buttonType" :icon="buttonIcon" :shape="buttonShape" :size="buttonSize">{{buttonValue}}</Button>
      </span>
      <span v-if="!isActive">
        <Button :type="buttonType" :icon="buttonIcon" :shape="buttonShape" :size="buttonSize" disabled>{{buttonValue}}</Button>
      </span>
  </span>
</template>
<script>

  export default {
    name: 'RuleButton',
    props: {
      type: {
        type: String,
        default () {
          return 'primary'
        },
      },
      shape: {
        type: String,
        default () {
          return null
        },
      },
      icon: {
        type: String,
        default () {
          return ''
        },
      },
      size: {
        type: String,
        default () {
          return null
        },
      },
      permissionName: {
        type: String,
        default () {
          return ''
        },
      },
      value: {
        type: String,
        default () {
          return ''
        },
      },
      clickEvent: {
        type: Function
      },
    },
    data () {
      return {
        buttonType: this.type,
        buttonShape: this.shape,
        buttonIcon: this.icon,
        buttonSize: this.size,
        buttonValue: this.value,
        isActive: true,
        permission: '',
        ruleButtons: null
      }
    },
    methods: {
    },
    mounted: function () {
      let self = this
      if (self.permissionName) {
        self.isActive = false
        let buttons = self.ruleButtons
        if (buttons) {
          if (buttons === 'all') {
            self.isActive = true
          } else {
            for (var index = 0; index < buttons.length; index++) {
              if (buttons[index] === self.permissionName) {
                self.isActive = true
              }
            }
          }
        }
      }
    },
    created: function () {
      let self = this
      self.$http.get('/adminRule/getUserRuleButton').then(function (res) {
        if (res.data) {
          self.ruleButtons = res.data
        }
      })
    },
    watch: {
    }
  }
</script>



// WEBPACK FOOTER //
// RuleButton.vue?9620657a